import { PublicClientApplication, Configuration, AuthenticationResult } from "@azure/msal-browser";

const msalConfig: Configuration = {
  auth: {
    clientId: "090c40b5-9bef-494b-a935-a6d1afe6a7db",
    authority: "https://login.microsoftonline.com/consumers",
    redirectUri: "/auth-callback",
    postLogoutRedirectUri: "/",
  },
};

let msalInstance: PublicClientApplication | null = null;

export function getMsalInstance(): PublicClientApplication | null {
  if (msalInstance) {
    return msalInstance;
  }

  msalInstance = new PublicClientApplication(msalConfig);
  return msalInstance;
}

export async function getAccessToken(
  scopes: string[]
): Promise<AuthenticationResult | undefined> {
  try {
    const instance = getMsalInstance();
    await instance?.initialize();
    const account = instance?.getActiveAccount() ?? undefined;

    if (account === undefined) {
      return undefined;
    }

    const accessToken =
      (await instance?.acquireTokenSilent({
        scopes: scopes,
        account: account,
        redirectUri: msalConfig.auth.redirectUri,
      })) ?? undefined;

    if (accessToken === undefined) {
      instance?.loginRedirect();
    }
    return accessToken;
  } catch (error) {
    console.error("Failed to acquire access token:", error);
    return undefined;
  }
}
